import { IconButton } from "@/components/ui/icon-button";
import { cn } from "@/utils/utils";
import { forwardRef, ReactNode } from "react";

interface HeaderActionProps {
  icon: ReactNode;
  className?: string;
  iconClassName?: string;
  tooltipText?: string;
  onClick?: (e: React.MouseEvent) => void;
}

const HeaderAction = forwardRef<HTMLButtonElement, HeaderActionProps>(
  ({ icon, className, iconClassName, tooltipText, onClick }, ref) => {
    return (
      <IconButton
        ref={ref}
        size="xs"
        iconColor="tertiary"
        variant="iconNoBg"
        className={cn(
          "group/column transition-opacity duration-200",
          className
        )}
        iconClassName={cn(
          "transition-colors duration-200 group-hover/column:!text-primary",
          iconClassName
        )}
        tooltipText={tooltipText}
        onClick={onClick}
      >
        {icon}
      </IconButton>
    );
  }
);

HeaderAction.displayName = "HeaderAction";

export default HeaderAction;
